import React, { ReactNode } from 'react'
import { Toaster } from 'react-hot-toast'

import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'

import { AuthAPIDocs } from '../pages/AuthAPIDocs'
import { ClientAPIDocs } from '../pages/ClientAPIDocs'
import { InternalClientAPIDocs } from '../pages/InternalClientAPIDocs'
import { InternalSCAPIDocs } from '../pages/InternalSCAPIDocs'

import { AccessRequired } from '../components/AccessRequired'
import { ScanResultDisplay } from '../components/ScanResultDisplay'
import { SnackbarHub } from '../snackbar'

import { PrivacyPolicy, TermsOfUse } from '../modules/auth/pages'
import { AdminRouter } from '../modules/admin/routes'
import { AuthRouter } from '../modules/auth/routes'
import { ClientRouter } from '../modules/client/routes'
import { KioskRouter } from '../modules/kiosk/routes'
import { SupplyChainRouter } from '../modules/supply_chain/routes'

import { skuit } from '../services/skuit'

interface AccountTypeRouteProps {
  type: string
  children: ReactNode
}

interface AccountTypeRouterProps {
  children: ReactNode
}

export const AccountTypeRouter = (props: AccountTypeRouterProps) => {
  const { children } = props
  if (!skuit.auth.isAuthed()) {
    return <Redirect to="/auth/logout" />
  }
  const accountType = skuit.auth.getAccountType()
  return (
    <>
      {React.Children.map(children, (child) => {
        const element = child as React.ReactElement<AccountTypeRouteProps>
        if (element?.props.type === accountType || element?.props.type === '*') {
          return child
        }
      })}
    </>
  )
}

export const AccountTypeRoute = (props: AccountTypeRouteProps) => {
  const { children } = props
  return <>{children}</>
}

const InnerRoutes = () => {
  return (
    <>
      <SnackbarHub />
      <Switch>
        <Route path="/auth">
          <AuthRouter />
        </Route>
        <Route path="/privacy-policy" exact>
          <PrivacyPolicy />
        </Route>
        <Route path="/terms-of-use" exact>
          <TermsOfUse />
        </Route>
        <Route path="/client-api/docs" exact>
          <ClientAPIDocs />
        </Route>
        <Route path="/auth-api/docs" exact>
          <AccessRequired>
            <AuthAPIDocs />
          </AccessRequired>
        </Route>
        <Route path="/internal/client-api/docs" exact>
          <AccessRequired>
            <InternalClientAPIDocs />
          </AccessRequired>
        </Route>
        <Route path="/internal/supply-chain-api/docs" exact>
          <AccessRequired>
            <InternalSCAPIDocs />
          </AccessRequired>
        </Route>
        <Route path="/admin">
          <AdminRouter />
        </Route>
        <Route path="/kiosk">
          <KioskRouter />
        </Route>
        <Route path="*">
          <AccountTypeRouter>
            <AccountTypeRoute type="client">
              <ScanResultDisplay />
              <ClientRouter />
            </AccountTypeRoute>
            <AccountTypeRoute type="supply_chain">
              <ScanResultDisplay />
              <SupplyChainRouter />
            </AccountTypeRoute>
          </AccountTypeRouter>
        </Route>
      </Switch>
    </>
  )
}

export const Routes = () => {
  return (
    <BrowserRouter>
      <InnerRoutes />
      <Toaster
        position="bottom-center"
        toastOptions={{
          duration: 5000,
          style: { minWidth: 500 },
          error: {
            style: {
              background: '#F44336',
              color: '#FFF',
            },
          },
          success: {
            style: {
              background: '#4CAF4F',
              color: '#FFF',
            },
          },
        }}
      />
    </BrowserRouter>
  )
}
